import * as constants from "../constants/index";

const process_major_class = (
  state = {
    text: "",
    masterItems: [],
    items: [],
    current: null,
    fetching: false,
    isError: false,
  },
  action
) => {
  switch (action.type) {
    case constants.PROCESS_MAJOR_CLASS_BEGIN_FETCH_ITEMS: {
      return {
        ...state,
        fetching: true,
        isError: false,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_END_FETCH_ITEMS: {
      return {
        ...state,
        masterItems: action.payload,
        items: action.payload,
        fetching: false,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_CHANGE_SEARCH_TEXT: {
      return {
        ...state,
        text: action.payload,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_BEGIN_SEARCH_ITEMS: {
      return {
        ...state,
        fetching: true,
        isError: false,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_END_SEARCH_ITEMS: {
      return {
        ...state,
        items: action.payload,
        fetching: false,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_END_FETCH_ITEM: {
      return {
        ...state,
        current: action.payload,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_END_CREATE_ITEM: {
      const masterItems = [...state.masterItems, action.payload];
      const items = masterItems.filter((item) => item.process_major_class_name.indexOf(state.text) >= 0);

      return {
        ...state,
        masterItems,
        items,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_END_UPDATE_ITEM: {
      const masterItems = state.masterItems.map((item) => {
        if (item.process_major_class_id === action.payload.process_major_class_id) {
          return action.payload;
        }

        return item;
      });

      const items = masterItems.filter((item) => item.process_major_class_name.indexOf(state.text) >= 0);

      return {
        ...state,
        masterItems,
        items,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_END_MERGE_ITEM: {
      const masterItems = state.masterItems.filter(
        (item) => item.process_major_class_id != action.payload.process_major_class_id
      );
      const items = masterItems.filter((item) => item.process_major_class_name.indexOf(state.text) >= 0);

      return {
        ...state,
        masterItems,
        items,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_BEGIN_DELETE_ITEM: {
      return {
        ...state,
        fetching: true,
        isError: false,
      };
    }
    case constants.PROCESS_MAJOR_CLASS_END_DELETE_ITEM: {
      return {
        ...state,
        masterItems: state.masterItems.filter((item) => item.process_major_class_id !== action.payload.id),
        items: state.items.filter((item) => item.process_major_class_id !== action.payload.id),
        fetching: false,
      };
    }
    case constants.APP_CHANGE_MENU: {
      return {
        ...state,
        text: "",
        items: [...state.masterItems],
      };
    }
    case constants.APP_SHOW_ERROR: {
      if (action.errorFrom === "process_major_class") {
        return {
          ...state,
          fetching: false,
          isError: true,
        };
      }

      return state;
    }
    default:
      return state;
  }
};

export default process_major_class;
